import { createReducer } from "@reduxjs/toolkit";

import { assert } from "@skilitics/nautilus-core-designer-data";

import { setActiveLanguageCodeAction, setPermissions, setRootNodeParentContextAction } from "./appConfigActions.ts";
import type { NautilusDesignerAppConfig } from "./shared.ts";

export const appConfigReducerCreate = (initialState: NautilusDesignerAppConfig) =>
  createReducer(initialState, (builder) => {
    builder.addCase(setActiveLanguageCodeAction, (draft, { payload: lang }) => {
      assert(lang, "Language code must be defined");
      draft.activeLang = lang;
    });
    builder.addCase(setPermissions, (draft, { payload: permissions }) => {
      draft.permissions = permissions;
    });
    builder.addCase(setRootNodeParentContextAction, (draft, { payload }) => {
      draft.rootNodeParentContext = payload;
    });
  });
